import styled from 'styled-components';

export const StyledCard = styled.div`
  padding: ${({ theme }) => theme.spacing(3)}px ${({ theme }) => theme.spacing(4)}px;
  border: 1px solid ${({ theme }) => theme.colors.on[50]};
  border-radius: ${({ theme }) => theme.radii.lg}px;
`;
